import enTranslation from './en/translation.json';

const locales = {
  en: {
    translation: enTranslation,
  },
};

export default locales;
